import axiosClient from "../axios/axiosClient";

export function getCampuses() {
  return axiosClient.get("/campuses");
}

export function getCampus(campusId) {
  return axiosClient.get(`/campuses/${campusId}`);
}

export function createCampus(data) {
  return axiosClient.post("/campuses", data);
}

export const updateCampus = (campusId, data) => {
  return axiosClient.put(`/campuses/${campusId}`, data);
};

export function deleteCampus(campusId) {
  return axiosClient.delete(`/campuses/${campusId}`);
}
